import { Component, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppUtils } from '../../../common/app.utils';
import { AdmCenter } from '../../../model/api/administration/adm-center';
import { Employee } from '../../../model/api/administration/employee';
import { PagedResult } from '../../../model/common/paged-result';
import { Param } from '../../../model/common/param';
import { AdmCenterHttpService } from '../../../services/http/administration/adm-center.http.service';
import { EmployeeHttpService } from '../../../services/http/administration/employee.http.service';
import { GenericManage, GenericManageViewMode } from '../../generic/generic.manage';
import { EmployeeListComponent } from '../employees/employee.list';
import { AdmCenterDetailComponent } from './adm-center.detail';
import { AdmCenterListComponent } from './adm-center.list';
@Component({
    selector: 'app-adm-center-manage',
    templateUrl: 'adm-center.manage.html',
    providers: [ AdmCenterHttpService,  EmployeeHttpService]
})
export class AdmCenterManageComponent extends GenericManage<AdmCenter, number> {

     // @ViewChild('itemDetailModal') modal: ModalDirective;
     @ViewChild('employeeListModal') employeeListModal: ModalDirective;
     @ViewChild('employeeList') employeeList: EmployeeListComponent;
     @ViewChild('admCenterDetailModal') admCenterDetailModal: ModalDirective;
     @ViewChild('admCenterList') admCenterList: AdmCenterListComponent;
     @ViewChild('admCenterDetail') admCenterDetail: AdmCenterDetailComponent;

     isCollapsed: boolean = true;
    public filter: string = '';
    public selectedEmployee: Employee = null;

    constructor(
        public admCenterHttpService: AdmCenterHttpService,
        public employeeHttpService: EmployeeHttpService) {
        super();
    }


    public addNewItem() {
        super.addNewItem();

        this.admCenterDetail.employee = null;
    }

    public editItem() {
        super.editItem();

        let admCenter: AdmCenter = this.selectedItem as AdmCenter;

        this.admCenterDetail.employee = null;

        if ((admCenter != null) && (admCenter.employeeId != null)) {
            this.employeeHttpService
                .getById(admCenter.employeeId)
                .subscribe((employee: Employee) => {
                    this.admCenterDetail.employee = employee;
                });
        }

    }

     public detailInitialize() {
        this.admCenterDetailModal.show();
    }

    public detailTerminate() {
        this.admCenterDetailModal.hide();
    }

    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));
        params.push(new Param('employeeIds', AppUtils.getIdsList<Employee, number>([ this.selectedEmployee ])));

        this.admCenterList.refresh(params);
    }


    public onAdmCenterDetailEmployeeNeeded() {
        this.admCenterDetailModal.hide();
        this.selectEmployee();
    }

    public onEmployeeListCancel() {
        this.employeeListModal.hide();
        if (this.viewMode === GenericManageViewMode.ItemDetail) {
            this.admCenterDetailModal.show();
        }
    }

    public selectEmployee() {
        this.employeeListModal.show();
        this.employeeList.refresh(null);
    }

    public setSelectedEmployee() {
        this.viewMode = 2;
        switch(this.viewMode) {

            case GenericManageViewMode.ItemList:
                this.selectedEmployee = this.employeeList.selectedItem;
                this.employeeListModal.hide();
                this.refresh();
                break;
            case GenericManageViewMode.ItemDetail:
                this.admCenterDetail.employee = this.employeeList.selectedItem;
                this.employeeListModal.hide();
                this.admCenterDetailModal.show();
                break;
            default:
                break;
        }
    }

    public unselectEmployee() {
        this.selectedEmployee = null;
        this.refresh();
    }



    public exportToExcel() {

        let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.admCenterHttpService.get(1, 1000000, 'name', 'asc', params, null).subscribe(
            (data: PagedResult<AdmCenter>) => {

                let options = {
                    sheetid: 'AssetTypes',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // alasql(`SELECT id as [Id],
                //     name as [Denumire],
                //     employee->firstName as [Gestionar Nume],
                //     employee->lastName as [Gestionar Prenume],
                //     employee->email as [Gestionar Email]
                //     INTO XLSX("AssetTypes.xlsx",?) FROM ?`, [ options, data.items ]);

            });
    }

    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
